

import React, { useState } from "react";

import image from "../../assests/home1.webp";
import { Button, Form, Input, notification } from "antd";
import { POST } from "../../utils/apicalls";
import { API } from "../../config/api";
import Header from "../componets/header/header";
import Footer from "../componets/footer/footer";

function Blog2() {
    const [isLoading, setIsLoading] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const submitHandler = async (values: any) => {
        try {
            let obj = {
                visitorsId: values.visitorsId,
                type: "visitor",
                visitors_name: values.visitors_name,
                date: values.date || new Date().toISOString(),
                visitors_email: values.visitors_email,
                visitors_purpose: "from website",
                employee_id: 1,
                visitors_phone: values.visitors_phone,
                description: values.description,
                altPhone: values.altPhone,
            };

            setIsLoading(true);
            const api = API.CREATE_VISITORS;
            const postRequest: any = await POST(api, obj);
            if (postRequest.status) {
                notification.success({ message: "visitors created successfully!" });
                setIsLoading(false);
                setIsModalOpen(false);
                form.resetFields();
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.log(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
            <Header />
            <div>
                <div style={{ position: "relative", textAlign: "center", color: "white" }}>
                    <img
                        src={image}
                        alt="Digital Marketing"
                        style={{ width: "100%", height: "100vh", objectFit: "cover" }}
                    />

                    <h1 style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontSize: "50px",
                        fontWeight: "900",
                        margin: 0
                    }}>
                        Digital Marketing Post
                    </h1>
                </div>


                <div style={{ padding: "20px" }} >
                    <h2 style={{ fontSize: "30px", fontWeight: "900" }}>
                        Your Weekly Dose of Digital Marketing Goodness Hey there, marketing
                        warriors!
                    </h2>
                    <p>
                        Welcome to the papadigitalsolution Blog, your one-stop shop for all
                        things digital marketing. We know the online world can feel like a
                        never-ending game of whack-a-mole – new trends popping up,
                        algorithms changing, and audiences with ever-shorter attention
                        spans. But fret not, fellow entrepreneur!
                    </p>
                    <p>
                        This blog is your digital marketing sherpa, here to guide you
                        through the ever-evolving online landscape. Each week, we’ll be
                        dishing out actionable tips, industry insights, and success stories
                        to equip you with the knowledge and strategies you need to dominate
                        the digital jungle. Best Digital marketing Agency In Kochi
                    </p>

                    <h2 style={{ fontSize: "30px", fontWeight: "900" }}>
                        What You Can Expect:
                    </h2>
                    <p>
                        Actionable Tactics You Can Use Today: Learn cutting-edge digital
                        marketing strategies you can implement right away – no fluff, just
                        practical advice to boost your website traffic, conversions, and
                        brand awareness.Trend Spotting and Deep Dives: We’ll keep you ahead
                        of the curve by analyzing the latest trends and hottest platforms in
                        the digital marketing world. Get ready for in-depth explorations of
                        everything from the metaverse to the rise of voice search.
                        Real-World Inspiration: Feeling stuck? No worries! We’ll share
                        inspiring stories of businesses like yours who are crushing it
                        online with killer digital marketing campaigns. Get ready for a
                        healthy dose of motivation and case studies you can learn from.
                        Jargon Busting 101: We speak your language! Complex digital
                        marketing terms will be broken down into bite-sized pieces, so you
                        can confidently navigate the online sphere and impress your
                        colleagues with your newfound knowledge. Here’s a Sneak Peek at
                        Upcoming Posts:
                    </p>
                    <p>
                        SEO SOS: 5 Mistakes Killing Your Website Traffic (and How to Fix
                        Them)Content is King (and Queen): How to Craft a Content Strategy
                        that Drives ResultsFrom Likes to Leads: The Ultimate Guide to
                        Creating Engaging Social Media ContentEmail Marketing Magic: Craft
                        Irresistible Campaigns that ConvertPaid Advertising Demystified: A
                        Beginner’s Guide to Google Ads and Social Media Ads Data Doesn’t
                        Lie: Using Analytics to Understand Your Audience and Optimize Your
                        Campaigns Looking for More Than Blog Posts?
                    </p>
                    <p>
                        Don’t settle for stagnation in the ever-evolving digital landscape.
                        Unlock your business’s true potential with the power of our digital
                        marketing expertise. Subscribe now and join our vibrant community of
                        growth-hungry marketers!
                    </p>
                    <p>
                        We don’t just talk the talk, we walk the walk! In addition to this
                        blog, we offer a range of digital marketing services to help you
                        achieve your online goals. From website design and development to
                        social media management and pay-per-click advertising, we’re your
                        one-stop shop for all your digital needs.
                    </p>
                    <p>Ready to Level Up Your Digital Marketing Game?</p>
                    <p>
                        Subscribe to our blog and get ready for a weekly dose of digital
                        marketing goodness delivered straight to your inbox. With our
                        insightful content and your dedication, we can turn your online
                        presence into a lead-generating machine. Let’s conquer the digital
                        world, together!
                    </p>
                </div>
                <div style={{}}>
                    <h2
                        style={{

                            fontSize: "30px",
                            fontWeight: "900",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        Leave a Reply
                    </h2>
                    <p
                        style={{


                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        Your email address will not be published. Required fields are marked
                        *
                    </p>
                    <Form
                        form={form}
                        name="contact_form"
                        onFinish={submitHandler}
                        layout="vertical"
                        style={{ maxWidth: "600px", margin: "0 auto" }}
                    >
                        <Form.Item
                            name="visitors_name"
                            rules={[{ required: true, message: "Please input your name!" }]}
                        >
                            <Input placeholder="Enter your name" />
                        </Form.Item>
                        <Form.Item
                            name="visitors_email"
                            rules={[
                                {
                                    required: true,
                                    type: "email",
                                    message: "Please input a valid email!",
                                },
                            ]}
                        >
                            <Input placeholder="Enter your email" />
                        </Form.Item>
                        <Form.Item
                            name="visitors_phone"
                            rules={[
                                { required: true, message: "Please input your phoone number" },
                            ]}
                        >
                            <Input placeholder="Enter phone number" />
                        </Form.Item>
                        <Form.Item
                            name="description"
                            rules={[
                                { required: true, message: "Please input your message!" },
                            ]}
                        >
                            <Input.TextArea placeholder="Enter your message" rows={4} />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" block>
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Blog2;
